import React from "react";

export default function Services() {

  return (
    <div className="service-page">

      {/* FORM */}
      <div className="form-card">
        <h2></h2>

        <form >
          <div className="form-row">
            <input
              type="text"
              name="title"
              placeholder="Service Title"
            
            />
            <input
              type="text"
              name="key"
              placeholder="Key"
             
            />
          </div>

          <div className="form-row">
            <input
              type="text"
              name="icon"
              placeholder="Icon (bi-...)"
             
            />
          </div>

          <h3>Details</h3>

            <div className="detail-card" >
              <input
                type="text"
                placeholder="Detail Title"
                
              />
              <textarea
                placeholder="Content"
              
              />
            </div>
          

          <button type="button">+ Add Detail</button>
          <button type="submit">save</button>
        </form>
      </div>

      {/* TABLE */}
      <div className="table-card">
        <h2>📋 Service List</h2>

        <table className="service-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Key</th>
              <th>Icon</th>
              <th>Details</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            
              <tr>
                <td colSpan="6">No services</td>
              </tr>
         
          </tbody>
        </table>
      </div>

    </div>
  );
}